import React from "react";
import { Button, Card, Empty, Input, Space, Typography } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import type { QuizSituation } from "../../../services/gameQuiz/gameQuiz.types";
import ImageUploadInput from "./ImageUploadInput";
import { createSituation } from "./examSituations";

type Props = {
  situations: QuizSituation[];
  onChange: (situations: QuizSituation[]) => void;
  onRemove: (id: string) => void;
};

const SituationsEditor: React.FC<Props> = ({
  situations,
  onChange,
  onRemove,
}) => {
  const update = (id: string, changes: Partial<QuizSituation>) =>
    onChange(
      situations.map((situation) =>
        situation.id === id ? { ...situation, ...changes } : situation,
      ),
    );

  const remove = (id: string) => {
    if (
      window.confirm(
        "¿Eliminar esta situación? Sus preguntas quedan sin situación.",
      )
    ) {
      onRemove(id);
    }
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Typography.Text type="secondary">
        Una situación es un texto, con imagen opcional, que comparten varias
        preguntas seguidas del examen. Asígnala desde cada pregunta.
      </Typography.Text>
      {situations.length === 0 && (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="El examen no tiene situaciones."
        />
      )}
      {situations.map((situation, index) => (
        <Card
          key={situation.id}
          size="small"
          title={`Situación ${index + 1}`}
          extra={
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              aria-label={`Eliminar situación ${index + 1}`}
              onClick={() => remove(situation.id)}
            />
          }
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <div>
              <label htmlFor={`situation-text-${situation.id}`}>Texto</label>
              <Input.TextArea
                id={`situation-text-${situation.id}`}
                autoSize={{ minRows: 3, maxRows: 12 }}
                value={situation.text}
                status={situation.text.trim() ? undefined : "error"}
                placeholder="Texto de la situación que leen las preguntas"
                onChange={(event) =>
                  update(situation.id, { text: event.target.value })
                }
              />
            </div>
            <div>
              <label>Imagen</label>
              <ImageUploadInput
                value={situation.image_url ?? undefined}
                onChange={(url) =>
                  update(situation.id, { image_url: url ?? null })
                }
              />
            </div>
          </Space>
        </Card>
      ))}
      <Button
        icon={<PlusOutlined />}
        onClick={() => onChange([...situations, createSituation()])}
      >
        Agregar situación
      </Button>
    </Space>
  );
};

export default SituationsEditor;
